import React, {useState, useEffect, useLayoutEffect, useReducer} from 'react';
import ResponsiveNavigation from '../components/ResponsiveNavigation'
import logo from '../../../assets/images/ceba-logo-white-text.png';
import Api from '../../Api'
import PersonIcon from '@material-ui/icons/Person';
import BusinessIcon from '@material-ui/icons/Business';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

function NavBarContainer() {
  const [navbarData, setNavbarData] = useState({})
  const [navLinks, setNavLinks] = useState([])

  useLayoutEffect(() => {
    Api.getSessionInfo()
      .then(user => {
        if (user !== undefined) {
          setNavbarData(user)
          const links = resolveNavLinks(user)
          setNavLinks(links)
      }})
  }, [])

  const resolveConversations = (user) => {
    if (user.notifications.unread_messages === 0) {
      return 'My Conversations'
    } else return(
      `My Conversations (${user.notifications.unread_messages})`
    )
  }

  const handleInviteLink = (user) => {
    if (window.location.pathname === `/organizations/${user.organization.id}`) {
      window.location.href = `/organizations/${user.organization.id}#invitations`
      setTimeout(() => {
        location.reload()
      }, 100)
    } else {
      window.location.href = `/organizations/${user.organization.id}#invitations`
    }
  }

  const resolveAdminSubLinks = (user) => {
    switch (user.primary_affiliation.role) {
      case 'admin':
        return [
          {text: 'New Users', path: '/admin/pending_users'},
          {text: 'Current Users', path: '/admin/users'},
          {text: 'Organizations', path: '/admin/organizations'},
          {text: 'Resources', path: '/admin/resources'},
          {text: 'Events', path: '/admin/events'},
          {text: 'Forums', path: '/admin/forums'},
          {text: 'Utility', path: '/utility'}
        ]
      case 'member':
        return [
          {text: 'Users', path: '/admin/users'},
          {text: 'Organizations', path: '/admin/organizations'},
          {text: 'Resources', path: '/admin/resources'},
          {text: 'Events', path: '/admin/events'}
        ]
    }
  }

  const resolveNavLinks = (user) => {
    if (user.organization !== undefined) {
      switch (user.organization.role) {
        case 'admin':
          return [
            {
              text: 'Discover',
              path: '/',
              subLinks: [
                {text: 'Events', path: '/events'},
                {text: 'Resources', path: '/polities/us?tab=resources'},
                {text: 'International Resources', path: '/international_resources'},
                {text: 'Roadmap', path: '/pages/roadmap'}
              ]
            },
            {
              text: 'Connect',
              path: '/',
              subLinks: [
                {text: 'CEBA Network', path: '/users'},
                {text: 'My Network', path: `/users/${user.id}/connections`}
              ]
            },
            {
              text: 'Discuss',
              path: '/',
              subLinks: [
                {text: 'Forums', path: '/forums'},
                {text: resolveConversations(user), path: `/users/${user.id}/conversations`}
              ]
            },
            {
              text: 'Admin',
              path: '/',
              subLinks: resolveAdminSubLinks(user)
            },
            {
              notification: true,
              path: `/users/${user.id}/notifications`,
              subLinks: []
            },
            {
              text: user.full_name,
              avatar: user.avatar_url,
              userDash: true,
              path: '/',
              subLinks: [
                {
                  text: 'Profile',
                  path: `/users/${user.id}`,
                  icon: <PersonIcon />
                },
                {
                  text: 'Company',
                  path: `/organizations/${user.organization.id}`,
                  icon: <BusinessIcon />
                },
                {
                  text: 'Invite Colleagues',
                  callback: () => handleInviteLink(user),
                  icon: <GroupAddIcon />
                },
                {
                  text: 'Change Password',
                  path: '/users/edit',
                  icon: <VpnKeyIcon />
                },
                {
                  text: 'Sign Out',
                  path: '/users/sign_out',
                  icon: <ExitToAppIcon />
                }
              ]
            }
          ]
        case 'utility':
        case 'government':
        case 'education':
        case 'ngo':
          return [
            {
              text: 'Discover',
              path: '/',
              subLinks: [
                {text: 'Resources', path: '/polities/us?tab=resources'}
              ]
            },
            {
              text: 'Connect',
              path: '/',
              subLinks: [
                {text: 'CEBA Network', path: '/users'},
                {text: 'My Network', path: `/users/${user.id}/connections`}
              ]
            },
            {
              text: 'Discuss',
              path: '/',
              subLinks: [
                {text: 'Forums', path: '/forums'},
                {text: resolveConversations(user), path: `/users/${user.id}/conversations`}
              ]
            },
            {
              notification: true,
              path: `/users/${user.id}/notifications`,
              subLinks: []
            },
            {
              text: user.full_name,
              avatar: user.avatar_url,
              userDash: true,
              path: '/',
              subLinks: [
                {
                  text: 'Profile',
                  path: `/users/${user.id}`,
                  icon: <PersonIcon />
                },
                {
                  text: 'Company',
                  path: `/organizations/${user.organization.id}`,
                  icon: <BusinessIcon />
                },
                {
                  text: 'Invite Colleagues',
                  callback: () => handleInviteLink(user),
                  icon: <GroupAddIcon />
                },
                {
                  text: 'Change Password',
                  path: '/users/edit',
                  icon: <VpnKeyIcon />
                },
                {
                  text: 'Sign Out',
                  path: '/users/sign_out',
                  icon: <ExitToAppIcon />
                }
              ]
            }
          ]
        case 'buyer':
          return [
            {
              text: 'Discover',
              path: '/',
              subLinks: [
                {text: 'Events', path: '/events'},
                {text: 'Resources', path: '/polities/us?tab=resources'},
                {text: 'Roadmap', path: '/pages/roadmap'}
              ]
            },
            {
              text: 'Connect',
              path: '/',
              subLinks: [
                {text: 'CEBA Network', path: '/users'},
                {text: 'My Network', path: `/users/${user.id}/connections`}
              ]
            },
            {
              text: 'Discuss',
              path: '/',
              subLinks: [
                {text: 'Forums', path: '/forums'},
                {text: resolveConversations(user), path: `/users/${user.id}/conversations`}
              ]
            },
            {
              notification: true,
              path: `/users/${user.id}/notifications`,
              subLinks: []
            },
            {
              text: user.full_name,
              avatar: user.avatar_url,
              userDash: true,
              path: '/',
              subLinks: [
                {
                  text: 'Profile',
                  path: `/users/${user.id}`,
                  icon: <PersonIcon />
                },
                {
                  text: 'Company',
                  path: `/organizations/${user.organization.id}`,
                  icon: <BusinessIcon />
                },
                {
                  text: 'Invite Colleagues',
                  callback: () => handleInviteLink(user),
                  icon: <GroupAddIcon />
                },
                {
                  text: 'Change Password',
                  path: '/users/edit',
                  icon: <VpnKeyIcon />
                },
                {
                  text: 'Sign Out',
                  path: '/users/sign_out',
                  icon: <ExitToAppIcon />
                }
              ]
            }
          ]
        case 'service_provider':
          return [
            {
              text: 'Discover',
              path: '/',
              subLinks: [
                {text: 'Events', path: '/events'},
                {text: 'Resources', path: '/polities/us?tab=resources'},
                {text: 'Roadmap', path: '/pages/roadmap'}
              ]
            },
            {
              text: 'Connect',
              path: '/',
              subLinks: [
                {text: 'CEBA Network', path: '/users'},
                {text: 'My Network', path: `/users/${user.id}/connections`}
              ]
            },
            {
              text: 'Discuss',
              path: '/',
              subLinks: [
                {text: 'Forums', path: '/forums'},
                {text: resolveConversations(user), path: `/users/${user.id}/conversations`}
              ]
            },
            {
              notification: true,
              path: `/users/${user.id}/notifications`,
              subLinks: []
            },
            {
              text: user.full_name,
              avatar: user.avatar_url,
              userDash: true,
              path: '/',
              subLinks: [
                {
                  text: 'Profile',
                  path: `/users/${user.id}`,
                  icon: <PersonIcon />
                },
                {
                  text: 'Company',
                  path: `/organizations/${user.organization.id}`,
                  icon: <BusinessIcon />
                },
                {
                  text: 'Invite Colleagues',
                  callback: () => handleInviteLink(user),
                  icon: <GroupAddIcon />
                },
                {
                  text: 'Change Password',
                  path: '/users/edit',
                  icon: <VpnKeyIcon />
                },
                {
                  text: 'Sign Out',
                  path: '/users/sign_out',
                  icon: <ExitToAppIcon />
                }
              ]
            }
          ]
        case 'developer':
          return [
            {
              text: 'Discover',
              path: '/',
              subLinks: [
                {text: 'Events', path: '/events'},
                {text: 'Resources', path: '/polities/us?tab=resources'},
                {text: 'Roadmap', path: '/pages/roadmap'}
              ]
            },
            {
              text: 'Connect',
              path: '/',
              subLinks: [
                {text: 'CEBA Network', path: '/users'},
                {text: 'My Network', path: `/users/${user.id}/connections`}
              ]
            },
            {
              text: 'Discuss',
              path: '/',
              subLinks: [
                {text: 'Forums', path: '/forums'},
                {text: resolveConversations(user), path: `/users/${user.id}/conversations`}
              ]
            },
            {
              notification: true,
              path: `/users/${user.id}/notifications`,
              subLinks: []
            },
            {
              text: user.full_name,
              avatar: user.avatar_url,
              userDash: true,
              path: '/',
              subLinks: [
                {
                  text: 'Profile',
                  path: `/users/${user.id}`,
                  icon: <PersonIcon />
                },
                {
                  text: 'Company',
                  path: `/organizations/${user.organization.id}`,
                  icon: <BusinessIcon />
                },
                {
                  text: 'Invite Colleagues',
                  callback: () => handleInviteLink(user),
                  icon: <GroupAddIcon />
                },
                {
                  text: 'Change Password',
                  path: '/users/edit',
                  icon: <VpnKeyIcon />
                },
                {
                  text: 'Sign Out',
                  path: '/users/sign_out',
                  icon: <ExitToAppIcon />
                }
              ]
            }
          ]
      }
    }
    else {
      return []
    }
  }

  return (
    <ResponsiveNavigation
      navLinks={ navLinks }
      logo={ logo }
      background="#2f3a48"
      hoverBackground="#1e8ecd"
      linkColor="#fff"
      currentUser={ navbarData }
    />
  );
}
export default NavBarContainer;
